import { render, staticRenderFns } from "./OutboundSettings.vue?vue&type=template&id=96f1edb8&scoped=true&"
import script from "./OutboundSettings.vue?vue&type=script&lang=js&"
export * from "./OutboundSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f1edb8",
  null
  
)

/* custom blocks */
import block0 from "./OutboundSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports